import { startMerchantWorkflow } from '../../api/onboarding/onboarding';
import { Merchant, MerchantWorkflow } from '../../types/onboarding/Merchant';
import ResponseError from '../../types/response/ResponseError';

/**
 * Opens a Bits workflow of the merchant in a new tab. Bits does not support embedding its flow (the applicant session
 * lives in cookies, and BankID/bank steps navigate away), so the workflow opens in a new tab. The tab is reserved
 * synchronously, which popup blockers allow when this is called from a click handler, and pointed at the session URL
 * once the backend has issued it.
 */
export const openMerchantWorkflow = (
    organizationId: string,
    merchant: Merchant,
    workflow: MerchantWorkflow,
    startWorkflowStarted: (workflow: MerchantWorkflow, merchant: Merchant) => void,
    startWorkflowSucceeded: (workflow: MerchantWorkflow, merchant: Merchant) => void,
    startWorkflowFailed: (workflow: MerchantWorkflow, error: ResponseError) => void
) => {
    const tab = window.open('about:blank', '_blank');

    if (tab) tab.opener = null;

    startMerchantWorkflow(
        organizationId,
        merchant,
        workflow,
        startWorkflowStarted,
        (startedWorkflow, startedMerchant, session) => {
            if (tab) tab.location.href = session.url;
            else window.open(session.url, '_blank', 'noopener');

            startWorkflowSucceeded(startedWorkflow, startedMerchant);
        },
        (failedWorkflow, error) => {
            tab?.close();
            startWorkflowFailed(failedWorkflow, error);
        }
    );
};
